import { render } from "./Dossier.vue?vue&type=template&id=a97fba1e&scoped=true"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"

import "./Dossier.vue?vue&type=style&index=0&id=a97fba1e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97fba1e"]])

export default __exports__